import * as React from 'react';
import { Link } from 'react-router-dom';
import { Field, Fields } from 'redux-form/immutable';
import classNames from 'classnames';
import { Button, Loader } from 'semantic-ui-react';
import {
  Dropdown,
  FormLabelIcon,
  TitleBar,
  RegisterPayment,
} from '@/components/Common';
import { app, areaOptions, paths } from '@/config';
import {
  FieldDropdown,
  FieldInput,
  FieldTextArea,
  FieldSellDropzone,
  FieldCheckbox,
  FieldSaleDate,
} from '../../Form';
import enhance from './enhancer';
import { prefecture } from './misc';

import SellConfirmModal from './SellConfirmModal';
import Modal from '@/migration/modal';
import pesticidesAdditionalInfo from '@/config/app/pesticidesAdditionalInfo';

function Sell(props) {
  const {
    submitBiddingRegistration,
    formValues: { shipping_expense, soil, pesticides },
    handleSubmit,
    users,
    isLoading,
    modalIsOpen,
    setModalIsOpen,
    previewData,
    confirmSubmit,
    showErrorMessage,
    setShowErrorMessage,
  } = props;

  return (
    <div className="app_sell flex">
      <div
        className={classNames({
          wrap: true,
        })}
      >
        {/* users.myCreditCards.lengthの値を取りに行っている間Loaderを出す */}
        {isLoading ? (
          <div>
            <Loader
              active={isLoading}
              inline="centered"
              className="sell_loading"
            />
          </div>
        ) : !users.mydata.isSeller && !users.myCreditCards.length ? (
          // クレジットカードと売上げ口座を登録していない場合
          <div className="bidder_user_message_card">
            <RegisterPayment code="accountAndCard" />
          </div>
        ) : !users.myCreditCards.length ? (
          // クレジットカードを登録していない場合
          <div className="w__advise-register">
            <div className="bidder_user_message_card">
              <RegisterPayment code="card" />
            </div>
          </div>
        ) : !users.mydata.isSeller ? (
          // 売上げ口座を登録していない場合
          <div className="w__advise-register">
            <div className="bidder_user_message_card">
              <RegisterPayment code="account" />
            </div>
          </div>
        ) : (
          <form
            className={classNames({
              flex: true,
              app_pointer_event_none:
                !users.mydata.isSeller || !users.myCreditCards.length,
            })}
            onSubmit={handleSubmit(submitBiddingRegistration)}
          >
            {/* タイトルと出品方法誘導文言の追加 柳生 */}
            <TitleBar title="出品情報の入力" />
            <div className="field_wrapper">
              <label className="flex attention">
                ※出品方法については
                <Link to={paths.introduction.sell} target="_blank">
                  こちら
                </Link>
                から
              </label>
              <label className="flex attention">
                ※元払い出品の送料については
                <Link to={paths.introduction.prepayment} target="_blank">
                  こちら
                </Link>
                から
              </label>
            </div>
            {/* 出品画像表示位置をfield_wrapperでラッピング 柳生 */}
            <div className="field_wrapper image_group">
              <Field
                name="sellImages"
                component={FieldSellDropzone}
                type="image"
                change={props.change}
                users={props.users}
                uploadIsImageLoading={props.uploadIsImageLoading}
                isImageLoading={props.isImageLoading}
              />
            </div>
            <div className="field_wrapper">
              <label className="flex">
                商品名
                <span className="word_count">(最大50文字)</span>
                <FormLabelIcon value="必須" />
              </label>
              <Field
                name="name"
                type="text"
                placeholder=""
                component={FieldInput}
                disabled={!users.mydata.isSeller}
                maxLength={50}
              />
            </div>

            {/* 追加 */}
            <div className="field_wrapper">
              <label className="flex">
                品種名
                <span className="word_count">(最大50文字)</span>
                <FormLabelIcon value="必須" />
              </label>
              <Field
                name="breed"
                type="text"
                placeholder="例) りんご"
                component={FieldInput}
                disabled={!users.mydata.isSeller}
                maxLength={50}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                サイズ（JA規格）
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="size"
                className="size"
                component={FieldDropdown}
                selection
                fluid
                options={[
                  {
                    key: '0',
                    value: null,
                    name: '',
                    text: '未選択',
                  },
                  ...app.size,
                ]}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
              />
            </div>
            <div className="field_wrapper">
              <Field
                name="is_unevenness"
                className="w__is_ikejime"
                component={FieldCheckbox}
                label="不揃い"
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                重量
                <span className="word_count">(最大10,000,000g)</span>
                <FormLabelIcon value="任意" optional />
              </label>
              <div className="weight_wrap">
                <Field
                  name="weight"
                  placeholder="例) 1500"
                  label={{ basic: true, content: 'g' }}
                  labelPosition="right"
                  disabled={!users.mydata.isSeller}
                  component={FieldInput}
                  maxLength={8}
                />
              </div>
              <Field
                name="weight_additional_info"
                placeholder="備考"
                disabled={!users.mydata.isSeller}
                component={FieldInput}
                maxLength={50}
              />
              <span className="word_count_under">(最大50文字)</span>
            </div>

            <div className="field_wrapper">
              <label className="flex">
                生産者
                <span className="word_count">(最大50文字)</span>
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="producer"
                type="text"
                placeholder="例) 山田さん"
                component={FieldInput}
                disabled={!users.mydata.isSeller}
                maxLength={50}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                等級
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="grade"
                className="grade"
                component={FieldDropdown}
                selection
                fluid
                options={[
                  {
                    key: '0',
                    value: null,
                    name: '',
                    text: '未選択',
                  },
                  ...app.grade,
                ]}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                産地
                <FormLabelIcon value="任意" optional />
              </label>
              <div className="fishing_spot_wrap">
                <Field
                  search
                  fluid
                  className="prefecture"
                  name="origin"
                  component={Dropdown}
                  placeholder="選択してください"
                  options={prefecture}
                  noResultsMessage="該当する産地はありません"
                />
              </div>
              <Field
                name="origin_additional_info"
                placeholder="詳細ポイント"
                disabled={!users.mydata.isSeller}
                component={FieldInput}
                maxLength={50}
              />
              <span className="word_count_under">(最大50文字)</span>
            </div>

            <div className="field_wrapper">
              <label className="flex">
                平均糖度
                <span className="word_count">(最大10,000%)</span>
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="average_sugar_content"
                placeholder="例) 10.0"
                label={{ basic: true, content: '%' }}
                labelPosition="right"
                disabled={!users.mydata.isSeller}
                component={FieldInput}
                maxLength={5}
              />
            </div>

            <div className="field_wrapper fishing_date">
              <label className="flex">
                収穫日
                <FormLabelIcon value="任意" optional />
              </label>
              <div className="w__date-wrapper">
                <Fields
                  names={[
                    'fishing_date',
                    'fishing_year',
                    'fishing_month',
                    'fishing_day',
                  ]}
                  component={FieldSaleDate}
                />
              </div>
            </div>

            <div className="field_wrapper">
              <Field
                name="is_land_after_fix"
                className="w__is_ikejime"
                component={FieldCheckbox}
                label="落札後収穫"
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                収穫タイミング
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="harvest_timing"
                className="harvest_timing"
                component={FieldDropdown}
                selection
                fluid
                options={[
                  {
                    key: '0',
                    value: null,
                    name: '',
                    text: '未選択',
                  },
                  ...app.harvestTiming,
                ]}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
              />
            </div>
            {/* 
            <div className="field_wrapper">
              <label className="flex">
                栽培方法
                <FormLabelIcon value="任意" />
              </label>
              <Field
                name="cultivation_method"
                className="cultivation_method"
                component={FieldDropdown}
                selection
                fluid
                options={app.cultivationMethod}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
              />
            </div> */}

            <div className="field_wrapper">
              <label className="flex">
                出品者側保管方法
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="save_method_seller"
                className="save_method_seller"
                component={FieldDropdown}
                selection
                fluid
                options={[
                  {
                    key: '0',
                    value: null,
                    name: '',
                    text: '未選択',
                  },
                  ...app.saveMethod,
                ]}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                ご家庭での推奨保管方法
                <FormLabelIcon value="任意" optional />
              </label>
              <div className="fishing_spot_wrap">
                <Field
                  name="save_method_user"
                  className="save_method_user"
                  component={FieldDropdown}
                  selection
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未選択',
                    },
                    ...app.saveMethod,
                  ]}
                  placeholder="選択してください"
                  disabled={!users.mydata.isSeller}
                />
              </div>
              <Field
                name="save_method_user_additional_info"
                placeholder="詳細）日の当たらない涼しい場所に保管してください。"
                disabled={!users.mydata.isSeller}
                component={FieldInput}
                maxLength={50}
              />
              <span className="word_count_under">(最大50文字)</span>
            </div>

            <div className="field_wrapper">
              <label className="flex">
                栽培方法
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="cultivation_method"
                className="cultivation_method"
                component={FieldDropdown}
                selection
                fluid
                options={[
                  {
                    key: '0',
                    value: null,
                    name: '',
                    text: '未選択',
                  },
                  ...app.cultivationMethod,
                ]}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                土壌
                <FormLabelIcon value="任意" optional />
              </label>
              <div className="fishing_spot_wrap">
                <Field
                  name="soil"
                  className="save_method_user"
                  component={FieldDropdown}
                  selection
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未選択',
                    },
                    ...app.soil,
                  ]}
                  placeholder="選択してください"
                  disabled={!users.mydata.isSeller}
                />
              </div>
              {soil === 4 && (
                <div className="stack_checkbox">
                  {app.soilAdditionalInfo.map((e) => {
                    return (
                      <Field
                        name={`soil_additional_info[${e.key}]`}
                        className="w__is_ikejime"
                        component={FieldCheckbox}
                        label={e.text}
                        key={e.key}
                      />
                    );
                  })}
                </div>
              )}
            </div>

            <div className="field_wrapper">
              <label className="flex">
                農薬
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="pesticides"
                className="cultivation_method"
                component={FieldDropdown}
                selection
                fluid
                options={[
                  {
                    key: '0',
                    value: null,
                    name: '',
                    text: '未選択',
                  },
                  ...app.pesticides,
                ]}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
              />
              {pesticides === 2 && (
                <>
                  <Field
                    name="pesticides_additional_info[0]"
                    placeholder="節減対象農薬を節減「当地比〇割減、〇〇地域比○割減）」"
                    disabled={!users.mydata.isSeller}
                    component={FieldInput}
                    maxLength={50}
                  />
                  <span className="word_count_under">(最大50文字)</span>
                </>
              )}
              {pesticides === 3 && (
                <div className="stack_checkbox">
                  {pesticidesAdditionalInfo.map((e) => {
                    return (
                      <Field
                        name={`pesticides_additional_info[${e.key}]`}
                        className="w__is_ikejime"
                        component={FieldCheckbox}
                        label={e.text}
                        key={e.key}
                      />
                    );
                  })}
                </div>
              )}
            </div>

            <div className="field_wrapper">
              <label className="flex">
                遺伝子組み換え
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="genetic"
                className="cultivation_method"
                component={FieldDropdown}
                selection
                fluid
                options={[
                  {
                    key: '0',
                    value: null,
                    name: '',
                    text: '未選択',
                  },
                  ...app.genetic,
                ]}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                有機JAS認定
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="jas"
                className="jas"
                component={FieldDropdown}
                selection
                fluid
                options={[
                  {
                    key: '0',
                    value: null,
                    name: '',
                    text: '未選択',
                  },
                  ...app.jas,
                ]}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                個別的義務表示事項
                <span className="word_count">(最大50文字)</span>
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="individual_obligations"
                type="text"
                placeholder="アレルゲン、消費期限又は賞味期限、添加物など"
                component={FieldInput}
                disabled={!users.mydata.isSeller}
                maxLength={50}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                グローバルGAP
                <FormLabelIcon value="任意" optional />
              </label>

              <Field
                name="global_gap"
                className="w__is_ikejime"
                component={FieldCheckbox}
                label="認証"
              />
              {/* <Field
                name="global_gap"
                type="text"
                placeholder="例) りんご"
                component={FieldInput}
                disabled={!users.mydata.isSeller}
                maxLength={50}
              /> */}
            </div>

            {/* ここまで */}

            <div className="field_wrapper">
              <label className="flex">
                配送料の負担
                <FormLabelIcon value="必須" />
              </label>
              <Field
                name="shipping_expense"
                className="defrayment"
                selection
                fluid
                options={app.shippingExpense.filter(
                  ({ value }) =>
                    value !== 3 ||
                    (props.users.mydata.isCompany &&
                      props.users.mydata.shippingProvider !== 0 &&
                      props.shippingCosts.id !== 0 &&
                      props.shippingCosts.user_id !== 0)
                )}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
                component={FieldDropdown}
              />
            </div>
            {shipping_expense === 3 ? (
              <div className="field_wrapper">
                <label className="flex">
                  配送サイズ区分
                  <FormLabelIcon value="必須" />
                </label>
                <Field
                  component={FieldDropdown}
                  disabled={false}
                  fluid={true}
                  name="shipping_size"
                  options={app.shippingSize}
                  placeholder="選択してください"
                  selection={true}
                />
              </div>
            ) : null}
            <div className="field_wrapper">
              <label className="flex">
                配送方法
                <FormLabelIcon value="必須" />
              </label>
              <Field
                name="delivery_method"
                selection
                fluid
                options={app.deliveryMethod}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
                component={FieldDropdown}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                発送までの日数
                <FormLabelIcon value="必須" />
              </label>
              <Field
                name="shipping_timing"
                selection
                fluid
                options={app.shippingTiming}
                placeholder="選択してください"
                disabled={!users.mydata.isSeller}
                component={FieldDropdown}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                発送元の地域
                <FormLabelIcon value="必須" />
              </label>
              <Field
                fluid
                className="prefecture"
                name="area"
                component={Dropdown}
                placeholder="選択してください"
                options={areaOptions}
                noResultsMessage="該当する発送元の地域はありません"
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                出品時の開始価格
                <FormLabelIcon value="必須" />
              </label>
              <Field
                name="price"
                placeholder="入力してください"
                label={{ basic: true, content: '¥' }}
                labelPosition="left"
                disabled={!users.mydata.isSeller}
                component={FieldInput}
                maxLength={8}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                即決価格
                <FormLabelIcon value="任意" optional />
              </label>
              <Field
                name="fix_price"
                placeholder="入力してください"
                label={{ basic: true, content: '¥' }}
                labelPosition="left"
                disabled={!users.mydata.isSeller}
                component={FieldInput}
                maxLength={8}
              />
            </div>

            <div className="field_wrapper">
              <label className="flex">
                出品期限
                <FormLabelIcon value="必須" />
              </label>
              <div className="close_bid_min">
                <Field
                  fluid
                  name="close_bid_min_date"
                  placeholder="選択してください"
                  className="expired"
                  disabled={!users.mydata.isSeller}
                  component={Dropdown}
                  options={app.closeBidMinDate}
                  noResultsMessage="該当する出品期限はありません"
                  type="number"
                />
                <Field
                  fluid
                  name="close_bid_min_hour"
                  placeholder="選択してください"
                  className="expired"
                  disabled={!users.mydata.isSeller}
                  component={Dropdown}
                  options={app.closeBidMinHour}
                  noResultsMessage="該当する出品期限はありません"
                  type="number"
                />
              </div>
            </div>

            <div className="field_wrapper description">
              <label className="flex">
                出品商品説明
                <FormLabelIcon value="必須" />
              </label>
              <Field
                rows={5}
                name="explanation"
                component={FieldTextArea}
                disabled={!users.mydata.isSeller}
                maxLength={1001}
              />
              <span className="word_count_under">(最大1000文字)</span>
            </div>

            {/* <div className="field_wrapper form_last">
              <label className="flex compliance_container">
                遵守事項
                <FormLabelIcon value="必須" />
              </label>
              <div className="compliance_wrap">
                <Field
                  name="red_list_check"
                  className="compliance_checkbox"
                  disabled={!users.mydata.isSeller}
                  component={FieldRedListAgreement}
                />
              </div>
              <div className="compliance_wrap">
                <Field
                  name="rare_spacies_check"
                  className="compliance_checkbox"
                  disabled={!users.mydata.isSeller}
                  component={FieldRareSpeciesAgreement}
                />
              </div>
              <div className="compliance_wrap">
                <Field
                  name="toxic_fish_confirm"
                  className="compliance_checkbox"
                  disabled={!users.mydata.isSeller}
                  component={FiealdToxicFishAgreement}
                />
              </div>
              <div className="compliance_wrap">
                <Field
                  className="compliance_checkbox"
                  name="release_check"
                  component={FieldCheckboxAgreement}
                  disabled={!users.mydata.isSeller}
                  label="未成商品はリリースしてください"
                />
              </div>
            </div> */}

            <div className="field_wrapper bottom">
              <Button
                fluid
                className="btn_sell"
                disabled={!users.mydata.isSeller || props.isSellLoading}
                loading={props.isSellLoading}
              >
                出品する
              </Button>
            </div>

            <Modal
              className="sell-modal"
              isModal={modalIsOpen}
              handleCloseModal={() => {
                setModalIsOpen(false);
              }}
              ModalBody={SellConfirmModal}
              previewData={previewData}
              mydata={users?.mydata}
              confirmSubmit={confirmSubmit}
              loading={props.isSellLoading}
              showErrorMessage={showErrorMessage}
              setShowErrorMessage={setShowErrorMessage}
            />
          </form>
        )}
      </div>
    </div>
  );
}

export default enhance((props) => <Sell {...props} />);
